// import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ProductListQuery from 'Query/ProductList.query';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { getIndexedProducts } from 'Util/Product';
import { prepareQuery } from 'Util/Query';
import { executeGet } from 'Util/Request';
import getStore from 'Util/Store';

import YBProductoAsociado from './YBProductoAsociado.component';

/** @namespace Elganso/Component/YBProductoAsociado/Container */
export class YBProductoAsociadoContainer extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    state = {
        productoAsociadoFinal: null
    };

    containerFunctions = {
        closePopupProductoAsociado: this.closePopupProductoAsociado.bind(this)
        // getData: this.getData.bind(this)
    };

    componentDidMount() {
        const { productoAsociado } = this.props;

        if (productoAsociado) {
            const relatedSKUs = [];
            relatedSKUs.push(productoAsociado);

            const options = {
                args: { filter: { productsSkuArray: relatedSKUs } }
            };

            executeGet(prepareQuery(ProductListQuery.getQuery(options))).then(
                /** @namespace Elganso/Component/YBProductoAsociado/Container/YBProductoAsociadoContainer/componentDidMount/executeGet/then */
                (result) => {
                    if (result?.products?.items) {
                        if (result.products.items.length > 0) {
                            const productoAsociadoFinal = getIndexedProducts(result.products.items)[0];
                            this.setState({ productoAsociadoFinal });
                        }
                    }
                }
            );
        }
    }

    closePopupProductoAsociado() {
        const store = getStore();
        const { dispatch } = store;
        dispatch(hideActiveOverlay());
    }

    containerProps() {
        const {
            sku,
            productoAsociado
        } = this.props;

        const {
            productoAsociadoFinal
        } = this.state;

        return {
            sku,
            productoAsociado,
            productoAsociadoFinal
        };
    }

    render() {
        return (
            <YBProductoAsociado
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default YBProductoAsociadoContainer;
